// libraries.
import { PolygonF } from '@react-google-maps/api';
import {
  skyBlue200,
  skyBlue700,
  error,
  scarpaGray300,
  scarpaGray800,
} from '@habitech/shared';

// hooks.
import { useMedianZonesForMarketMaker } from '../hooks';

// types.
import type { MedianZone } from '../store/api-slices';

const getPolygonOptions = (zone: MedianZone) => {
  if (zone.polygon_status === 1) {
    return {
      fillColor: skyBlue200,
      fillOpacity: 0.4,
      strokeColor: skyBlue700,
      strokeOpacity: 0.5,
      strokeWeight: 1,
    };
  }

  if (zone.polygon_status === 0) {
    return {
      fillColor: 'rgba(229, 23, 23, 0.4)',
      fillOpacity: 1,
      strokeColor: error,
      strokeOpacity: 0.5,
      strokeWeight: 1,
    };
  }

  return {
    fillColor: scarpaGray300,
    fillOpacity: 0.3,
    strokeColor: scarpaGray800,
    strokeOpacity: 0.5,
    strokeWeight: 1,
  };
};

export const MedianZonesPolygons = () => {
  const { medianZones, isLoading } = useMedianZonesForMarketMaker();

  if (isLoading || !medianZones || medianZones.length === 0) {
    return null;
  }

  return (
    <>
      {medianZones.map(zone => {
        const options = getPolygonOptions(zone);

        return (
          <PolygonF
            key={zone.label}
            path={zone.polygon.map(point => ({
              lat: point.lat,
              lng: point.lng,
            }))}
            options={options}
          />
        );
      })}
    </>
  );
};
